
 import { mapState } from 'vuex'
 import dayjs from 'dayjs' // 时间转换
 import dealerMt from '@/components/company/v2/dealerMt.vue'
 import individuaidentification from '@/components/company/v2/individuaidentification.vue'
 import authenticationmt from '@/components/company/v2/authenticationmt.vue'
 import dealerh5mt45 from '@/components/company/v2/dealer-h5-mt45.vue'
 import companyBasic from '@/components/company/v2/companyBasic.vue'
 import dealerctradeMt from '@/components/company/v2/dealerctradeMt.vue'
 import { HexToRGB } from '~/utils/utils.js'
 export default {
   name: 'SoftwareV2',
   components: {
    dealerMt,
    dealerctradeMt,
    individuaidentification,
    'authen-ticationmt':authenticationmt,
    'dealer-h5mt': dealerh5mt45,
    companyBasic
   },
   inject: ['detail','softResult'],
   data() {
     return {
      headData: this.detail?.main,
      isTwoLine: false,
      softval: {},
      bodywidth: 0,
      softCount: 0,
      updateDate: '',
      showsoftData: [],
      isSoftLeftRoll: true,
      isSoftRightRoll: false,
      isSoftwareSideLeft: false,
      isSoftwareSideRight: false,
      isSoftwareScrolledToLeft: false,
      isSoftwareScrolledToRight: false,
      tabsoftshow: false,
      isSideLeft: false,
      isRightRoll: false,
      isLeftRoll: true,
      isSideRight: false,
      isScrolledToRight: false,
      isScrolledToLeft: false,
      isIpDialog: false, // ip 弹框
      serverTabList: [],
      serverDataList: [],
      allServersData: [],
      mt4ServersData: [],
      mt5ServersData: [],
      serverIPObj: {}, // ip 弹框list数据
      companyBasic: {},
      ismtipd:false,
      leverDataList: [],
      isLeverPop: false
     };
   },
   computed: {
    ...mapState({
      isMobile: 'mobile'
    }),
     isZh() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
   },
   watch: {},
   created() {
   },
   mounted() {
    console.log('headData',this.headData);
    console.log(this.softResult?.items, '1111');
    window?.addEventListener('resize', this.screenFn)
    this.allServersData = this.softResult?.serverList?.allServers || []
    this.mt4ServersData = this.softResult?.serverList?.mT4_Servers || []
    this.mt5ServersData = this.softResult?.serverList?.mT5_Servers || []
    this.serverDataList = this.allServersData
    setTimeout(()=>{
      this.$refs.countrywid && this.$refs.countrywid.forEach((item,ind)=>{
        if(item.clientWidth >= 117.9) this.serverDataList[ind].widmax = true
        else this.serverDataList[ind].widmax = false
      })
    },100)
    
    setTimeout(() => {
      this.slideHidden()
      this.softSlideHidden()
      this.setTagStyle()
    }, 200)
      console.log(this.softResult, 'softResult');
    // 整理tab 数据
    if (this.softResult?.serverList?.allServers?.length) {
        this.serverTabList.push({
          isActive: true,
          name: '全部服务器',
          tebType: 'all'
        })
    }
     if (this.softResult?.serverList?.mT4_Servers?.length) {
        this.serverTabList.push({
          isActive: false,
          name: 'MT4',
          tebType: 'mt4'
        })
    }
     if (this.softResult?.serverList?.mT5_Servers?.length) {
        this.serverTabList.push({
          isActive: false,
          name: 'MT5',
          tebType: 'mt5'
        })
    }

    this.bodywidth = document && document.documentElement && document.documentElement.clientWidth
    if (this.bodywidth > 1199 && this.softResult?.items?.length > 4) {
      this.tabsoftshow = true
      this.showsoftData = this.softResult?.items?.slice(0, 4)
    } else {
      this.showsoftData = this.softResult?.items
    }

    console.log(this.showsoftData,'相关软件数据...');
    window.addEventListener('resize', () => {
       this.setTagStyle() 
      this.bodywidth = document && document.documentElement && document.documentElement.clientWidth
      if (this.bodywidth > 1199 && this.softResult?.items?.length > 4) {
        this.tabsoftshow = true
        this.showsoftData = this.softResult?.items?.slice(0, 4)
      } else {
        this.showsoftData = this.softResult?.items
      }
    })
    console.log('serverDataList', this.serverDataList)
    console.log('softResult', this.softResult)
  },
  methods: {
    leverPopClick (item) {
      if (!item || !item.leverage) {
        return
      }
      this.leverDataList = item.leverageDetailList
      this.isLeverPop = true
    },
    openauthenticat() {
      if(this.$store.state.mobile){
        this.$nextTick(() => {
        this.$refs.h5mtDom.showMt()
      })
      }else{
        this.$refs.authenticat.show()
      }
    },
    ipclone(){
      // console.log('弹框关闭');
      const ele = document.querySelector('.only-outer-border')
      if (ele?.length > 0) {
        ele.scrollTop = 0
      }
      
      // console.log('document.querySelecto ', document.querySelector('.only-outer-border'));
      // console.log('document.querySelecto ', document.querySelector('.only-outer-border'));
      if(!this.ismtipd) document.body.style.overflow = 'auto'
    },
    openIpDialog(item) {
      console.log('触发3', item);
      this.ismtipd = false
      console.log(item, 8886)
      if (item?.serverIPList?.list?.length) {
        this.serverIPObj = item.serverIPList
       this.updateDate = dayjs(new Date(Number(this.serverIPObj.updateDate))).format('YYYY-MM-DD')
       document.body.style.setProperty('overflow', 'hidden', 'important');
        this.isIpDialog = true
      }
      this.companyBasic = item.companyBasic
    },
    pingIcon(i) {
      if (i == 1) return 'https://resources1.interface003.com/web20/img/commen/green.gif'
      else if (i == 2) return 'https://resources1.interface003.com/web20/img/commen/yellow.gif'
      else if (i == 3) return 'https://resources1.interface003.com/web20/img/commen/red.gif'
      else return 'https://resources1.interface003.com/web20/img/commen/red.gif'
    },
    setTagStyle () {
       setTimeout(() => {
        this.$refs.tagDom.forEach((item) => {
            if (item.clientHeight > 35) {
              this.isTwoLine = true
            } else {
              this.isTwoLine = false
            }
        })
      }, 200)
    },
    openmt(item) {
      if (item.appBundleId) {
          const code = this.$route.params.id && this.$route.params.id.split('.')[0]
          const codeParams = item.marketId + '-' + item.appBundleId + '-' + code + '-' + (item.marketId == 11 ? 2 : 1)
          window.open(`/${this.$store.state.LanguageCode}/softwareDetails/${codeParams}.html`)
        return
      }
      // 打开相关软件弹框
      console.log(item, 9999)
      
      for (const key in item) {
        this.$set(this.softval, key, item[key])
      }
      console.log('softval-open',this.softval)
      if (item.softwareType != 3 && item.softwareType != 4) {
        if (this.$store.state.mobile) {
          this.$nextTick(() => {
            this.$refs.h5mtDom.showMt(item)
          })
        } else {
          this.$refs.individuaident.open()
        }
      }
      else if(item.softwareType == 3) this.$refs.dealerctradeMt.open() // ctrade弹框
      else {
        this.$refs.dealerMt.open()
      }
    },
    pre() {
      if (this.softCount <= 0) {
        return
      }
      this.softCount--
      const left = `-${Number(this.softCount * 173)}px`
      document.getElementById('sd-tab-position').style.transform = `translateX(${left})`
    },
    next() {
      if (this.softCount >= this.softResult?.items?.length - 4) {
        return
      }
      this.softCount++
      const left = `-${Number(this.softCount * 173)}px`
      document.getElementById('sd-tab-position').style.transform = `translateX(${left})`
    },
    serviceTabClick(itemClick, i) {
      const _this = this
      _this.serverTabList.forEach((item, index) => {
        if (index == i) {
          item.isActive = true
        } else {
          item.isActive = false
        }
      })
        if (itemClick.tebType == 'all') {
          _this.serverDataList = _this.allServersData
        } else if (itemClick.tebType == 'mt4') {
          _this.serverDataList = _this.mt4ServersData
        } else if (itemClick.tebType == 'mt5') {
          _this.serverDataList = _this.mt5ServersData
        }
        setTimeout(() => {
          this.slideHidden()
          this.$refs.countrywid && this.$refs.countrywid.forEach((item,ind)=>{
            if(item.clientWidth >= 117.9) this.serverDataList[ind].widmax = true
            else this.serverDataList[ind].widmax = false
          })
          this.$forceUpdate()
        }, 200)
        this.$refs.wrapperCon.style.transition = 'transform 0.3s';
        this.$refs.wrapperCon.scrollLeft = '0px'
    },
    // 服务器数据右滑事件
    rightSlide() {
           let left = this.$refs.wrapperCon.scrollLeft
            // 保存元素的整体宽度
            const scrollWidth = this.$refs.wrapperCon.scrollWidth
            // 保存元素的可见宽度
            const clientWidth = this.$refs.wrapperCon.clientWidth
            console.log('clientWidth', clientWidth);
            // 获取当前元素的宽度
            // const itemWidth = this.$refs.warpItem[0].clientWidth
            let pointNum = null
            let integerNum = null
            const onceNum = clientWidth / 10
            if (String(onceNum).indexOf(".") >= 1) {
              const parts = String(onceNum).split('.');
              pointNum = Number(parts[1])
              integerNum = Number(parts[0])
            } else {
              integerNum = onceNum
            }
            console.log(clientWidth, 'itemWidth');
            let num = 0
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                // 已经滚动距离+可见宽度
                // left+clientWidth>=scrollWidth：滚动到最右侧
                // num>=itemWidth一次性滚动距离
                if (left + clientWidth >= scrollWidth || num >= clientWidth - pointNum) {
                    clearInterval(this.timer)
                    this.$refs.wrapperCon.scrollLeft = this.$refs.wrapperCon.scrollLeft + 12 + pointNum
                    return
                }
                // 给滚动盒子元素赋值向左滚动距离
                this.$refs.wrapperCon.scrollLeft = left += integerNum
                // 保存向左滚动距离（方便判断一次性滚动多少距离）
                num += integerNum
            }, 20)
            // this.isSideLeft = true
      },
    // 服务器数据 点击左滑
    leftSlide() {
            let left = this.$refs.wrapperCon.scrollLeft
            let num = 0
            // 保存元素的可见宽度
            const clientWidth = this.$refs.wrapperCon.clientWidth
            //  const itemWidth = this.$refs.warpItem[0].clientWidth
              let pointNum = null
            let integerNum = null
            const onceNum = clientWidth / 10
            if (String(onceNum).indexOf(".") >= 1) {
              const parts = String(onceNum).split('.');
              pointNum = Number(parts[1])
              integerNum = Number(parts[0])
            } else {
              integerNum = onceNum
            }
            clearInterval(this.timer)
            this.timer = null
            this.timer = setInterval(() => {
                //   !left:已经滚动到最左侧
                //   一次性滚动距离（可调节）
                if (!left || num >= clientWidth - pointNum) {
                    // 停止滚动
                    clearInterval(this.timer)
                    this.$refs.wrapperCon.scrollLeft = this.$refs.wrapperCon.scrollLeft - (12 + pointNum)
                    this.timer = null
                    return
                }
                // 给滚动盒子元素赋值向左滚动距离
                this.$refs.wrapperCon.scrollLeft = left -= integerNum
                // 保存向左滚动距离（方便判断一次性滚动多少距离）
                num += integerNum
            }, 20)
    },
     // 相关软件控制是否隐藏
    softSlideHidden() {
     const tempWidth = this.$refs.warpSoftItem && this.$refs.warpSoftItem[0].clientWidth * this.softResult?.items?.length
      if (tempWidth > this.$refs.entiretySoftItem.clientWidth) {
        this.isSoftwareSideRight = true
        this.isSoftwareSideLeft = true
      } else {
        this.isSoftwareSideRight = false
        this.isSoftwareSideLeft = false
      }
    },
    // 控制服务数据 左右切换是否隐藏
    slideHidden() {
     const tempWidth = this.$refs?.warpItem && this.$refs?.warpItem[0]?.clientWidth * this.serverDataList?.length
      if (tempWidth > this.$refs?.entiretyItem?.clientWidth) {
        this.isSideRight = true
        this.isSideLeft = true
      } else {
        this.isSideRight = false
        this.isSideLeft = false
      }
    },
    // 服务商数据滚动事件
    handleScroll(event) {
      const container = event.target;
      // 检查是否滚动到最右边
    //  this.isScrolledToRight = container.scrollWidth - container.clientWidth - container.scrollLeft <= 1;
      // 检查是否滚动到最左边
    //  this.isScrolledToLeft = container.scrollLeft === 0;
    // console.log(container.scrollLeft, 'container.scrollLeft');
      const isRight = container.scrollWidth - container.clientWidth - container.scrollLeft <= 1;
      if (isRight) {
        this.isRightRoll = true
      } else {
        this.isRightRoll = false
      }
      if (container.scrollLeft === 0) {
        this.isLeftRoll = true
      } else {
        this.isLeftRoll = false
      }
    },

    // 相关软件数据 右滑事件
    rightSoftSlide() {
           let left = this.$refs.wrapperSoftCon.scrollLeft
            // 保存元素的整体宽度
            const scrollWidth = this.$refs.wrapperSoftCon.scrollWidth
            // 保存元素的可见宽度
            const clientWidth = this.$refs.wrapperSoftCon.clientWidth
            // 获取当前元素的宽度
            const itemWidth = this.$refs.warpSoftItem[0].clientWidth
            let pointNum = null
            let integerNum = null
            const onceNum = itemWidth / 10
            if (String(onceNum).indexOf(".") >= 1) {
              const parts = String(onceNum).split('.');
              pointNum = Number(parts[1])
              integerNum = Number(parts[0])
            } else {
              integerNum = onceNum
            }
            let num = 0
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                // 已经滚动距离+可见宽度
                // left+clientWidth>=scrollWidth：滚动到最右侧
                // num>=itemWidth一次性滚动距离
                if (left + clientWidth >= scrollWidth || num >= itemWidth - pointNum) {
                    clearInterval(this.timer)
                    this.$refs.wrapperSoftCon.scrollLeft = this.$refs.wrapperSoftCon.scrollLeft + 12 + pointNum
                    return
                }
                // 给滚动盒子元素赋值向左滚动距离
                this.$refs.wrapperSoftCon.scrollLeft = left += integerNum
                // 保存向左滚动距离（方便判断一次性滚动多少距离）
                num += integerNum
            }, 20)
            // this.isSoftwareSideLeft = true
      },
    // 相关软件数据 左滑事件
    leftSoftSlide() {
            let left = this.$refs.wrapperSoftCon.scrollLeft
            let num = 0
            const itemWidth = this.$refs.warpSoftItem[0].clientWidth
            let pointNum = null
            let integerNum = null
            const onceNum = itemWidth / 10
            if (String(onceNum).indexOf(".") >= 1) {
              const parts = String(onceNum).split('.');
              pointNum = Number(parts[1])
              integerNum = Number(parts[0])
            } else {
              integerNum = onceNum
            }
            clearInterval(this.timer)
            this.timer = null
            this.timer = setInterval(() => {
                //   !left:已经滚动到最左侧
                //   一次性滚动距离（可调节）
                if (!left || num >= itemWidth - pointNum) {
                    // 停止滚动
                    clearInterval(this.timer)
                    this.$refs.wrapperSoftCon.scrollLeft = this.$refs.wrapperSoftCon.scrollLeft - (12 + pointNum)
                    this.timer = null
                    return
                }
                // 给滚动盒子元素赋值向左滚动距离
                this.$refs.wrapperSoftCon.scrollLeft = left -= integerNum
                // 保存向左滚动距离（方便判断一次性滚动多少距离）
                num += integerNum
            }, 20)
      },
      // 软件滚动事件
    handleSoftScroll(event) {
      const container = event.target;
      // 检查是否滚动到最右边
    //  this.isSoftwareScrolledToRight = container.scrollWidth - container.clientWidth - container.scrollLeft <= 1;
      // 检查是否滚动到最左边
    //  this.isSoftwareScrolledToLeft = container.scrollLeft === 0;
      const isRight = container.scrollWidth - container.clientWidth - container.scrollLeft <= 1;
      if (isRight) {
        this.isSoftRightRoll = true
      } else {
        this.isSoftRightRoll = false
      }
      if (container.scrollLeft === 0) {
        this.isSoftLeftRoll = true
      } else {
        this.isSoftLeftRoll = false
      }
    },
    openmtIpDialog(item) {
      console.log(item, 8886)
      this.ismtipd = true
      this.companyBasic = item?.companyBasic
      if (item?.serverIPList?.list?.length) {
        this.serverIPObj = item?.serverIPList
       this.updateDate = dayjs(new Date(Number(this.serverIPObj.updateDate))).format('YYYY-MM-DD')
        document.body.style.setProperty('overflow', 'hidden', 'important');
        this.isIpDialog = true
      }
    },
    TransColor(color, tm) {
      if (!color) {
        return ''
      } else {
        return HexToRGB(color, tm)
      }
    }
   }
 }
 